/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonalRequisitionScopeFilter } from './personalRequisitionScopeFilter';
import { PersonalRequisitionIncludeFilterItems } from './personalRequisitionIncludeFilterItems';


export interface PersonalRequisitionIncludeFilterInner { 
    relation?: PersonalRequisitionIncludeFilterInner.RelationEnum;
    scope?: PersonalRequisitionScopeFilter;
}
export namespace PersonalRequisitionIncludeFilterInner {
    export type RelationEnum = 'employeeReplace' | 'requisitionType' | 'jobPosition' | 'currentStatus' | 'immediateSuperior' | 'areaManager' | 'generalManager' | 'financeDirector' | 'requisitionComments' | 'requisitionStatusHistories' | 'createdByUser' | 'humanCapitalCompany' | 'company' | 'businessUnit';
    export const RelationEnum = {
        EmployeeReplace: 'employeeReplace' as RelationEnum,
        RequisitionType: 'requisitionType' as RelationEnum,
        JobPosition: 'jobPosition' as RelationEnum,
        CurrentStatus: 'currentStatus' as RelationEnum,
        ImmediateSuperior: 'immediateSuperior' as RelationEnum,
        AreaManager: 'areaManager' as RelationEnum,
        GeneralManager: 'generalManager' as RelationEnum,
        FinanceDirector: 'financeDirector' as RelationEnum,
        RequisitionComments: 'requisitionComments' as RelationEnum,
        RequisitionStatusHistories: 'requisitionStatusHistories' as RelationEnum,
        CreatedByUser: 'createdByUser' as RelationEnum,
        HumanCapitalCompany: 'humanCapitalCompany' as RelationEnum,
        Company: 'company' as RelationEnum,
        BusinessUnit: 'businessUnit' as RelationEnum
    };
}


